<!--
 * @Author: yzf
 * @Date: 2020-12-01 16:27:20
 * @LastEditTime: 2020-12-07 14:46:19
 * @LastEditors: yzf
 * @Description: 这是文件
 * @FilePath: /alex/Volumes/project/hex/wuwei/src/views/other/changeLog/index.vue
 * @大威天龙,世尊地藏,般若诸佛,般若巴麻空,没有bug
-->
<template>
  <div id="change-log">
    <div class="menu">
      <a-menu class='fix' :default-selected-keys="[finalLog.length && finalLog[0].version]">
        <a-menu-item v-for="log in finalLog" :key="log.version" @click='clickItem(log)'>
          <a-icon type="tag" />
          <span>{{log.date | toMonthString}} - {{log.version}}</span>
        </a-menu-item>
      </a-menu>
    </div>
    <div class="content">
      <h1 class="head">
        更新日志
      </h1>
      <div class="logs" ref='logs'>
        <div :id='"D"+log.date' class="log" v-for="log in finalLog" :key="log.version">
          <div class='top'>
            <div class="version">
              v{{log.version}}
            </div>
            <div class="date">
              {{log.date | toDateString}}
            </div>
          </div>
          <div class="items">
            <div class="item" v-for="(item, idx) in log.content" :key='idx'>
              {{idx+1}}.{{item}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'change-log',
  data () {
    return {
      logs: []
    }
  },
  computed: {
    finalLog () {
      const logs = JSON.parse(JSON.stringify(this.logs))
      return logs.sort((a, b) => b.date - a.date)
    }
  },
  methods: {
    clickItem (item) {
      this.$nextTick(() => {
        const dom = document.querySelector(`#D${item.date}`)
        dom && dom.scrollIntoView && dom.scrollIntoView({ block: 'center', behavior: 'smooth' })
      })
    }
  },
  filters: {
    toDateString (stamp) {
      return new Date(stamp).toLocaleString()
    },
    toMonthString (stamp) {
      return new Date(stamp).toLocaleString().split(' ')[0]
    }
  },
  mounted () {
    this.$get('/wuwei/api/logs/log').then(res => {
      this.logs = res.list
    })
  }
}
</script>

<style lang="less" scoped>
#change-log {
  display: flex;
  .menu {
    width: 316px;
    flex-shrink: 0;
    font-size: 16px;
    .fix {
      width: 100%;
      height: 100%;
      overflow: auto;
    }
  }
  .content {
    flex-grow: 1;
    padding: 20px;
    display: flex;
    flex-direction: column;
    h1 {
      font-size: 24px;
      flex-shrink: 0;
    }
    .logs {
      flex-grow: 1;
      overflow: auto;
      .log {
        margin-top: 20px;
        .top {
          display: flex;
          align-items: center;
          .version {
            width: auto !important;
            height: auto;
            font-size: 18px;
            font-weight: bold;
          }
          .date {
            margin-left: 8px;
            font-size: 14px;
            color: gray;
          }
        }
        .items {
          font-size: 14px;
          .item {
            margin-top: 4px;
            word-break: break-all;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
#change-log {
  .ant-menu-item {
    font-size: 14px;
    transition: none !important;
    &:hover {
      font-weight: bold;
      background: rgba(250,136,61,.08);
    }
    &.ant-menu-item-selected {
      background: rgba(250,136,61,.08);
    }
  }
}
</style>
